import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CommonSharedModule } from 'src/app/shared/common/common-shared.module';
import { KendoModule } from 'src/app/shared/kendo/kendo.module';
import { OnboardingSharedModule } from 'src/app/shared/onboarding/onboarding-shared.module';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login/login.component';
import { RememberMeComponent } from './remember-me/remember-me.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { SetPhonenumberComponent } from './set-phonenumber/set-phonenumber.component';
import { VerificationComponent } from './verification/verification.component';
import { VerifycodeComponent } from './verifycode/verifycode.component';
import { VerifyphonecodeComponent } from './verifyphonecode/verifyphonecode.component';
import { VerifyuserComponent } from './verifyuser/verifyuser.component';

const components = [
  LoginComponent,
  VerificationComponent,
  VerifyuserComponent,
  VerifycodeComponent,
  ForgotpasswordComponent,
  ResetpasswordComponent,
  RememberMeComponent,
  SetPhonenumberComponent,
  VerifyphonecodeComponent,
];

const modules = [
  CommonModule,
  LoginRoutingModule,
  CommonSharedModule,
  KendoModule,
  OnboardingSharedModule,
];

@NgModule({
  declarations: [...components],
  imports: [...modules],
  exports: [...components, ...modules],
})
export class LoginModule {}
